export const offerfitAppGroupIdUseCases = "/offerfit/:app_group_id/use_cases";

/**
 * Conman pipeline product types surfaced on digest items as `pipeline_type`.
 * Mirrors conman's `PipelineProductType` enum; `ofl_legacy` is intentionally
 * omitted — it is deprecated and being removed from the conman API.
 */
export const OFFERFIT_PIPELINE_TYPES = {
  GO: "go",
  PRO: "pro",
} as const;
